<template lang="pug">
v-flex#resumen-loans(xs12 sm12 md12 lg12)
  v-layout(row wrap)
    v-flex(xs12 sm12 md3 lg3)
    v-flex.header-loans(xs12 sm12 md6 lg6)
      h1.mb-4(v-if="$vuetify.breakpoint.mdAndUp") Resumen de préstamo
    v-flex(xs12 sm12 md3 lg3)
  v-layout.mt-1(row wrap justify-center)
    //- v-flex(xs12 lg1)
    v-flex(xs12 sm12 md6 lg5)
      v-layout.container-loans-detail(row wrap justify-center)
        v-flex.container-wrapper-loans-detail(xs12 sm10 md10 lg10)
          .block-1
            p.main.d-inline
              img(:src="icons.aboutLoan" alt="about-loan")
              h2.d-inline.omnesMedium Sobre mi préstamo:
            p.mb-0
              span Monto del préstamo
              span
                strong {{ possibilityInfo.amount }}
            p.mb-0
              span Número de cuotas
              span
                strong {{ (possibilityInfo.cuotaSeleccionada - possibilityInfo.periodoGraciaExtraDiferido) < 2 ? 1 : possibilityInfo.cuotaSeleccionada - possibilityInfo.periodoGraciaExtraDiferido }}
            p.mb-0
              span Valor de cuota
              span
                strong {{ possibilityInfo.currency + ' ' + possibilityInfo.cuota.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
            p.mb-0
              span Tasa de interés
              span
                strong {{ (possibilityInfo.tasaPrestamo * 100).toFixed(2) + '%' }}
          .block-2.mt-2
            p.main.d-inline
              img(:src="icons.aboutDate" alt="about-loan")
              h2.d-inline.omnesMedium Sobre tus fechas:
            p.mb-0
              span Inicio de pago
              span
                strong {{ possibilityInfo.fechaInicioPago.locale('es').format('MMMM YYYY').charAt(0).toUpperCase() + possibilityInfo.fechaInicioPago.locale('es').format('MMMM YYYY').slice(1) }}
            p.mb-0
              span Fin de pago
              span
                strong {{ possibilityInfo.fechaFinPago }}
          .block-3.mt-2
            p.main.d-inline
              img(:src="icons.aboutPolicy" alt="about-loan")
              h2.d-inline.omnesMedium Sobre mi póliza:
            p.mb-0
              span(v-if="possibilityInfo.rentaPorPagarDoble < 1") Ingreso actual
              span(v-else) Ingreso Doble actual
              span
                strong {{ possibilityInfo.currency + ' ' + possibilityInfo.currentRent.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
            p.mb-0
              span Ingreso nuevo
              span
                strong(v-if="possibilityInfo.rentaPorPagarDoble < 1") {{ possibilityInfo.currency + ' ' + Math.abs(possibilityInfo.rentaPorPagarMensual).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
                strong(v-else) {{ possibilityInfo.currency + ' ' + Math.abs(possibilityInfo.rentaPorPagarDoble).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
            p.mb-0
              span(v-if="$vuetify.breakpoint.mdAndUp") Monto de devolución actual
              span.omnesMedium(v-if="$vuetify.breakpoint.smAndDown") Monto devolución actual
              span
                strong {{ possibilityInfo.currency + ' ' + possibilityInfo.devolucionOriginal }}
            p.mb-0
              span(v-if="$vuetify.breakpoint.mdAndUp") Monto de devolución nuevo
              span.omnesMedium(v-if="$vuetify.breakpoint.smAndDown") Monto devolución nuevo
              span
                strong {{ possibilityInfo.currency + ' ' + possibilityInfo.devolucionFinal }}
          .block-4.mt-2(v-if="possibilityInfo.rentaPorPagarDoble > 0")
            span(style="color: #00A9FF !important;font-size: 14px;display: block;line-height: 1;") Aún estás dentro de tu periodo de pago de ingreso doble. Recuerda que cuando este culmine, se realizará el descuento sobre la renta simple acordada en las condiciones de tu póliza.
    v-flex(xs12 sm12 md6 lg4)
      v-layout.container-loans-financial(row wrap justify-center)
        v-flex(xs12 sm10 md10 lg10)
          h2.text-xs-center.mt-3.mb-2 ¿Dónde realizaremos el abono?
          .bank.mb-2
            .icon
              img.mt-1(:src="icons.bank" alt="bank")
            .text
              h3.omnesMedium Banco
              h3.info--text {{ bank }}
          .numberAccount.mb-2
            .icon.text-center
              img.mt-1.px-1(:src="icons.numberAccount" alt="bank")
            .text
              h3.omnesMedium Número de cuenta
              h3.info--text {{ numberAccount }}
        //- .disclaimer
        //-   p El abono se hará directamente al titular de la póliza y cuenta afiliada
        v-flex.text-xs-center.mb-5(xs12 sm7 md9 lg10)
          v-btn#confirm-loan(color="primary" :disabled="loader" @click="goToNextStep") Continuar
        //- h2.omnesMedium.mt-3.notification-1.text-xs-center ¿Aún no estás seguro?
          //- span.notification-2 Enviar el resumen de la solicitud a:
          //- .senders.mb-5
          //-   img(:src="icons.whatsapp" alt="whatsapp")
          //-   img(:src="icons.email" alt="email")
  //- LOADER PROCESS
  v-dialog(v-model="loader" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | Enviando código de confirmación...
        v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import quoter from './../../interfaces/quoter'
import { mapGetters, mapActions } from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: ['possibilityInfo', 'uniqueTrackId'],
  data () {
    return {
      loader: false,
      bank: null,
      numberAccount: null,
      icons: {
        aboutDate: require('./../../assets/loans/icons/about-dates.svg'),
        aboutLoan: require('./../../assets/loans/icons/about-loans.svg'),
        aboutPolicy: require('./../../assets/loans/icons/about-policy.svg'),
        numberAccount: require('./../../assets/loans/icons/number-account.svg'),
        whatsapp: require('./../../assets/loans/icons/whatsapp.svg'),
        email: require('./../../assets/loans/icons/email.svg'),
        bank: require('./../../assets/loans/icons/bank.svg')
      },
      amplitude: {
        events: {
          loanConfirmation: 'Confirmación de Préstamo',
          loanCodeSent: 'Código Préstamo Enviado',
          loanCodeNoSent: 'Código Préstamo No Enviado'
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo', 'basicInfo', 'functionsRules'])
  },
  methods: {
    ...mapActions('user', ['sendCodigoPrestamo', 'setTrackingClient']),
    goToNextStep () {
      let self = this
      this.loader = true
      this.sendCodigoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, numeroPoliza: localStorage.getItem('selPol') })
        .then(() => {
          this.loader = false
          const cronograma = quoter.makeQuotation(self.possibilityInfo)
          let currentPoliza = this.polizasInfo.filter(f => { return f.numeroPoliza === localStorage.getItem('selPol') })
          const metadata = {
            numeroPoliza: currentPoliza[0].numeroPoliza,
            productoConsultado: 'RRVV',
            subproductoConsultado: currentPoliza[0].codigoProducto
          }
          self.$root.$emit('npsInactivity', {seccion: 'Préstamos - Tercer paso', metadata})
          let hashAddData = {
            amount: self.possibilityInfo.amount,
            bank: self.bank,
            numberAccount: self.numberAccount,
            client: currentPoliza[0].contratante,
            product: currentPoliza[0].producto,
            refund: self.possibilityInfo.devolucionFinal,
            numberQuota: (self.possibilityInfo.cuotaSeleccionada - self.possibilityInfo.periodoGraciaExtraDiferido) < 2 ? 1 : self.possibilityInfo.cuotaSeleccionada - self.possibilityInfo.periodoGraciaExtraDiferido,
            amountQuota: self.possibilityInfo.currency + ' ' + self.possibilityInfo.cuota.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
            numberPolicy: currentPoliza[0].numeroPoliza,
            percent: (self.possibilityInfo.tasaPrestamo * 100).toFixed(2) + '%',
            startLoan: self.possibilityInfo.fechaInicioPrestamoMoment,
            startPay: self.possibilityInfo.fechaInicioPago,
            endPay: self.possibilityInfo.fechaFinPago,
            option: self.possibilityInfo.opcion
          }
          // - [SEND TRACKING]
          let hashT = [{
            categoria: 'Prestamos RPP-IFP',
            trackingId: this.uniqueTrackId,
            screen: 'codigo_verificacion',
            document: this.basicInfo.numeroDocumento,
            name: this.basicInfo.nombres,
            email: this.basicInfo.correo,
            phone: this.basicInfo.celular,
            data: '',
            errorType: '',
            errorData: '',
            date: Date.now()
          }]
          self.setTrackingClient(hashT)
          // - [SEND TRACKING]
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.loanConfirmation,
              {
                'Monto cotizado': self.possibilityInfo.amount,
                'Cuotas': (self.possibilityInfo.cuotaSeleccionada - self.possibilityInfo.periodoGraciaExtraDiferido) < 2 ? 1 : self.possibilityInfo.cuotaSeleccionada - self.possibilityInfo.periodoGraciaExtraDiferido,
                'Moneda': self.possibilityInfo.currency,
                'Opción': self.possibilityInfo.opcion
              }
            )
          self.$gtm.trackEvent({ event: 'Validacion' })
          self.$root.$emit('nextStep', { step: 3, cronograma: { source: cronograma, data: hashAddData } })
 
          
          this.$gtm.trackEvent({
            "event":"select_button",
            "Nombre Sección":"Zona Segura",
            "TipoElemento":"Botón",
            "TipoAccion":"Préstamo - paso 2 - continuar",
            "CTA":"Continuar"
      })

        })
        .catch(() => {
          // console.log(err)
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.loanCodeNoSent,
              {
                'Boton de no envío': 'No cuento con el teléfono a la mano'
              }
            )
        })
    }
  },
  mounted () {
    const self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
    let currentPoliza = this.polizasInfo.filter(f => { return f.numeroPoliza === localStorage.getItem('selPol') })
    this.bank = currentPoliza[0].banco
    this.numberAccount = currentPoliza[0].numeroCuentabanco

    this.$gtm.trackEvent({
      "event":"content-view",
      "content-name":"/zona-segura/prestamos/paso/resumen",
      "content-view-name":"Préstamo cotizador - paso 2" 
      })
  }
}
</script>

<style>
#resumen-loans .header-loans { text-align: center; }
#resumen-loans .header-loans h1 {
  margin-bottom: 1em;
}
#resumen-loans .block-1 p.main,
#resumen-loans .block-2 p.main,
#resumen-loans .block-3 p.main {
  font-family: 'Omnes Medium';
}
#resumen-loans .block-1 p.main img,
#resumen-loans .block-2 p.main img,
#resumen-loans .block-3 p.main img {
  width: 7%;
  margin-right: 10px;
  position: relative;
  top: 4px;
}
#resumen-loans .block-1 p:not(.main),
#resumen-loans .block-2 p:not(.main),
#resumen-loans .block-3 p:not(.main) {
  margin-bottom: 5px;
  padding-left: 2.5em;
  overflow: hidden;
  display: block;
}
/** Paraf for resumen of loan in block-3 */
#resumen-loans .block-1 p:not(.main) span:first-of-type,
#resumen-loans .block-2 p:not(.main) span:first-of-type,
#resumen-loans .block-3 p:not(.main) span:first-of-type {
  float: left;
}
#resumen-loans .block-1 p:not(.main) span:first-of-type + span,
#resumen-loans .block-2 p:not(.main) span:first-of-type + span,
#resumen-loans .block-3 p:not(.main) span:first-of-type + span {
  float: right;
}
/** Paraf for resumen of loan in block-3 */
#resumen-loans .flex .layout .flex .bank,
#resumen-loans .flex .layout .flex .numberAccount {
  overflow: hidden;
}
#resumen-loans .flex .layout .flex .bank .icon,
#resumen-loans .flex .layout .flex .numberAccount .icon {
  float: left;
  width: 8%;
  margin-right: 12px;
}
.loans #resumen-loans .bank .icon img {
  width: 100%;
}
#resumen-loans .flex .layout .flex .bank .text,
#resumen-loans .flex .layout .flex .numberAccount .text {
  float: left;
}
#resumen-loans .flex .layout .flex .bank .text p:first-child,
#resumen-loans .flex .layout .flex .numberAccount .text p:first-child {
  margin-bottom: 0;
  font-family: 'Omnes Medium';
  font-weight: normal;
}
#resumen-loans .flex .layout .flex .disclaimer {
  background-color: #cef1ff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 2em;
  width: 88%;
  padding-right: 2em;
}
#resumen-loans .flex .layout .flex .disclaimer p {
  color: var(--second-brand-color) !important;
  margin-bottom: 0;
}
#resumen-loans #confirm-loan {
  background-color: rgb(234,12,144) !important;
  /* border-color: rgb(234,12,144) !important;
  margin: 0;
  width: 88%;
  margin-bottom: 2em;
  padding: 10px 0;
  height: auto; */
}
#resumen-loans .senders {
  text-align: center;
  margin-top: 15px;
}
/*
#resumen-loans .container-loans-financial .flex .notification-1 {
  font-family: 'Omnes Medium';
  font-size: 15px;
  margin-bottom: 0;
  text-align: center;
}
*/
#resumen-loans .container-loans-financial .flex .notification-2 {
  text-align: center;
  display: block;
  width: 100%;
}
#resumen-loans .senders img:first-of-type { margin-right: 12px; }
#resumen-loans .senders img {
  cursor: pointer;
  width: 13%;
}
.container-loans-detail {
  padding-right: 30px;
}
.container-wrapper-loans-detail {
  border: 1px solid #DEDEDE;
  padding: 20px;
}
/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  .container-loans-detail { padding-right: 0; }
  .container-wrapper-loans-detail { padding: 13px; }
  #resumen-loans .block-1 p.main img, #resumen-loans .block-2 p.main img, #resumen-loans .block-3 p.main img {
    width: 9.5%;
    margin-right: 7px;
  }
  #resumen-loans .senders img { width: 3.7rem; }
  #resumen-loans #confirm-loan { width: 100%; }
  #resumen-loans .flex .layout .flex .disclaimer {
    width: 100%;
    padding-left: 1em;
    padding-right: 1em;
  }
  #resumen-loans .block-1 p:not(.main), #resumen-loans .block-2 p:not(.main), #resumen-loans .block-3 p:not(.main) {
    padding-left: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/LoansSecondStep.vue